import { Card as CardId } from "@ravalmatic/bridge-engine/core";
import { HandMode } from "../../../Types";
import { BasePlayerContainer } from "./BasePlayerContainer";
import { LOCAL_PLAYER_SEAT } from "../PlayerSeats";

export class PlayerContainer extends BasePlayerContainer {

    constructor(scene: Phaser.Scene, cards: readonly CardId[]) {

        super(scene, LOCAL_PLAYER_SEAT, cards, HandMode.HIDDEN);
    }

    public startBiddingEntrance(): void {

        this.hand.startBiddingEntrance();
    }

    public setAvatarClickHandler(handler: () => void): void {

        this.avatar.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(-60, -68, 120, 136),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            useHandCursor: true
        });
        this.avatar.on(Phaser.Input.Events.POINTER_UP, handler);
    }

    public setAvatarId(avatarId: number): void {

        this.avatar.setAvatarId(avatarId);
    }
}
